import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { Usuario } from '../interfaces/usuario';
import { DataService } from '../services/data.service';
import {  ModalController } from '@ionic/angular';
import { ModalInfoComponent } from '../components/modal-info/modal-info.component';


@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
})
export class HomePage implements OnInit {

  usuario: Usuario = {
    id: '',
    email: ''
  };

  reportes = [];
  reporte = '';
  constructor(private readonly authService: AuthService,
              private router: Router,
              private dataService: DataService,
              private modalCtrl: ModalController) {

    this.authService.getUserInfo();
    this.authService.getUsuario().subscribe(usuario => this.usuario = usuario);

  }

  ngOnInit() {

  }

  ionViewWillEnter(){
    this.obtenerReportes();
  }

  obtenerReportes(){
    this.dataService.getReportes(this.usuario).subscribe((res: any) => {
      this.reportes = res;
      const fijo = res.filter(reporte => reporte.nombre === 'Encuesta Pinos');
      if (fijo.length > 0) {
        this.reporte = fijo[0].url;
      }else{
        this.reporte = res[0].url;
      }
    });
  }

  logOut() {
    this.authService.logout()
      .then(() => this.router.navigate(['/']))
      .catch((e) => console.log(e.message));
  }

  async mostrarLista() {
    const modal = await this.modalCtrl.create({
      component: ModalInfoComponent,
      componentProps: {
        reportes: this.reportes
      }
    });

    modal.onDidDismiss()
      .then((url: any) => {
        if (url.data) {
          this.reporte = url.data;
        }
      });

    return await modal.present();
  }

}
